export default "__VITE_ASSET__Cw42HVP$__"